import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { CalendarScheduleNavModule } from '@app/src/app/components/CalendarScheduleNav';
import { CalendarScheduleOptionsModule } from '@app/src/app/components/CalendarScheduleOptions';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';

import { EventsHomeComponent } from './EventsHome.component';

@NgModule({
  imports: [
    // Minga dependencies
    MatSelectModule,
    CalendarScheduleOptionsModule,
    MgFormFieldModule,
    MgIconModule,
    CalendarScheduleNavModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    FormsModule,
  ],
  declarations: [EventsHomeComponent],
  exports: [EventsHomeComponent],
})
export class EventsHomeModule {}
